import React from 'react';
import Table from 'react-bootstrap/Table';

import config from '../config';

class DelNav extends React.Component {
  render() {
    let delegateId = this.props.delegateId;

    return (
      <div width="90%">
        <hr/>
        <p><b>Performance tools</b></p>
        <Table striped bordered hover variant="dark">
          <thead>
            <tr>
              <th><a className="white-a" href={"/delegates/"}>All Delegates</a></th>
              <th><a className="white-a" href={"/delegate/" + delegateId}>Summary</a></th>
              <th><a className="white-a" href={"/votes/" + delegateId}>Votes</a></th>
            </tr>
          </thead>
        </Table>
      </div>
    );
  }
}

export default DelNav;



// WEBPACK FOOTER //
// ./src/iotex/DelNav.js